export default __webpack_public_path__ + "static/media/p-5.bde9e167.png";